
import React from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";
import { useBoards } from "@/contexts/boards";

const DeleteBoardDialog = () => {
  const { operation, closeOperation, handleBoardDeleted } = useBoards();
  const { user } = useAuth();
  
  const isOpen = operation.isOpen && operation.type === "delete";
  const board = operation.board;

  if (!board) {
    return null;
  }

  const handleOpenChange = (open: boolean) => {
    console.log('[DeleteBoardDialog] handleOpenChange called with:', open);
    if (!open) {
      closeOperation();
      
      // TEMPORARY FIX: Force page refresh when dialog is closed
      setTimeout(() => {
        console.log('[DeleteBoardDialog] Forcing page refresh after dialog close');
        window.location.reload();
      }, 100);
    }
  };

  const handleDelete = async () => {
    if (!user) {
      toast.error("You must be logged in to delete a board");
      closeOperation();
      return;
    }

    try {
      console.log('[DeleteBoardDialog] handleDelete called');
      // Close the dialog first
      closeOperation();
      
      const { error } = await supabase
        .from("boards")
        .delete()
        .eq("id", board.id)
        .eq("user_id", user.id);

      if (error) throw error;
      
      // Show success message
      toast.success(`Board "${board.title}" deleted successfully`);
      
      // Notify parent
      handleBoardDeleted();
      
      // TEMPORARY FIX: Force page refresh after deletion
      setTimeout(() => {
        console.log('[DeleteBoardDialog] Forcing page refresh after delete');
        window.location.reload();
      }, 100);
    } catch (error) {
      console.error("Error deleting board:", error);
      toast.error("Failed to delete board");
      
      // TEMPORARY FIX: Force page refresh even on error
      setTimeout(() => {
        console.log('[DeleteBoardDialog] Forcing page refresh after error');
        window.location.reload();
      }, 100);
    }
  };

  return (
    <AlertDialog open={isOpen} onOpenChange={handleOpenChange}>
      <AlertDialogContent className="max-w-md">
        <AlertDialogHeader>
          <AlertDialogTitle>Delete Board</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to delete "{board.title}"? This action cannot be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction 
            onClick={handleDelete}
            className="bg-red-500 hover:bg-red-600 focus:bg-red-600 text-white"
          >
            Delete
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DeleteBoardDialog;
